import {connect} from 'react-redux';
import EntryRosterList from 'shared/EntryRosterList.jsx';
import {
  handleMoveDownClick,
  handleMoveUpClick,
  handleSearchEnterKeyPress,
  handleSearchChange,
  handleSearch,
  handleRosterPositionCleared
} from './actions';
import {
  setIsProfessional,
  setMemberAvgField
} from './actionTypes';

const mapStateToProps = state => ({
  source: state.admin.entryDetail.rosterPositions,
  sourceQty: state.admin.entryDetail.rosterPositions.length,
  bowlers: state.admin.entryDetail.bowlers
});

const mapDispatchToProps = dispatch => ({
  onSearchEnterKeyPress: (roster, event) => dispatch(handleSearchEnterKeyPress(roster, event)),
  onSearchChange: (roster, event) => dispatch(handleSearchChange(roster, event)),
  onSearch: data => dispatch(handleSearch(data)),
  onAvgChange: (position, value) => dispatch(setMemberAvgField(position, value)),
  onIsProfessionalChange: (position, value) => dispatch(setIsProfessional(position, value)),
  onMoveUpClick: index => dispatch(handleMoveUpClick(index)),
  onMoveDownClick: index => dispatch(handleMoveDownClick(index)),
  onRosterPositionCleared: index => dispatch(handleRosterPositionCleared(index))
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryRosterList);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryRosterListContainer.jsx